const Operations = () => {
  return (
    <div className='flex flex-col h-screen'>
      <div className='flex items-center py-2 ml-12 w-[92%]'>
        <h1 className='text-2xl text-orange-600'>Operations</h1>
      </div>
      <div className='flex-1 overflow-hidden mx-auto w-[95%]'>
        <iframe
          title='report'
          width='100%'
          height='100%'
          src='https://lookerstudio.google.com/embed/reporting/6ab80746-75f5-459f-b1ec-29d4074ae96a/page/p_8nywl3i6td'
          frameBorder='0'
          style={{ border: '0', margin: 'auto' }}
          allowFullScreen
          sandbox='allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox'
        ></iframe>
      </div>
    </div>
  );
};

export default Operations;
